<template>
 <!-- eslint-disable vue/no-mutating-props -->
 <a-col :sm="8" :xs="24" class="mb-25">
  <a-form-item label="Bevestigingsmail vertraging min (minuten)" name="confirmationDelayMinMinutes">
   <a-input v-model:value="form.confirmationDelayMinMinutes" :disabled="!canUpdate"
            onkeydown="if(event.key==='.'||event.key===','){event.preventDefault();}"
            placeholder="" type="number"/>
  </a-form-item>
 </a-col>
 <a-col :sm="8" :xs="24" class="mb-25">
  <a-form-item label="Bevestigingsmail vertraging max (minuten)" name="confirmationDelayMaxMinutes">
   <a-input v-model:value="form.confirmationDelayMaxMinutes" :disabled="!canUpdate"
            onkeydown="if(event.key==='.'||event.key===','){event.preventDefault();}"
            placeholder="" type="number"/>
  </a-form-item>
 </a-col>
</template>

<script>
export default {
 name: 'ProductConfirmationDelayFields',
 props: {
  form: {
   type: Object,
   required: true,
  },
  canUpdate: {
   type: Boolean,
   default: false,
  },
 },
};
</script>
